module.exports = __webpack_public_path__ + "img/login-user.3f61f966.png";